export default __webpack_public_path__ + "static/media/iconAndroid.f993ac71.svg";